import React from 'react';

export interface MuroDepContextProps {
  MicroComponent?: React.ComponentType<any>;
  MiniComponent?: React.ComponentType<any>;
  MobileComponent?: React.ComponentType<any>;
}

export const MuroDepContext = React.createContext<MuroDepContextProps>({});
MuroDepContext.displayName = 'MuroDepContext';
